import React, { useEffect } from "react";

import cn from "classnames";
import styles from "./Components.module.sass";

import { UseApi } from "../../../hooks/use-api";
import { GetNFTs } from "../../../Services/lib/nft";
import { listGenerator } from "..";

const CustomizeNftProducts = () => {
	const [{ isLoading, data }, fetch] = UseApi({
		service: GetNFTs,
	});

	useEffect(() => {
		fetch({
			limit: 8,
			offset: 1,
		});
	}, []);
	if (isLoading) {
		return (
			<div className={cn(styles.wrap, styles.p0)}>
				{listGenerator(8).map((e, i) => {
					return (
						<div
							key={`_${i + 1}_`}
							className={cn(styles.columnCon, styles.comMarketConBorder)}
						>
							<div className={styles.busyContainer} />
							<div className={styles.line1} />
							<div className={styles.line2} />
						</div>
					);
				})}
			</div>
		);
	}
	return (
		<>
			<div className={cn(styles.pflex, styles.phNft)}>
				{data?.nfts?.map((e, i) => {
					return <CCard key={`_card_${i}`} item={e} />;
				})}
			</div>
			<br />
		</>
	);
};

const CCard = ({ item }) => {
	return (
		<>
			<div className={styles.pcard}>
				<img src={item.image} className={styles.pImage} alt=" __image__" />
				<div className={styles.pName}>{item.name}</div>
				<div className={styles.price}>$ {item.price}</div>
			</div>
		</>
	);
};
export default CustomizeNftProducts;
